import { getAppConfig } from '@services/config';
import { cmsHttpService } from '@services/http';
import { CACHE_TAGS } from '@services/http/http';

const appConfig = getAppConfig();

export async function getUpsellModal(rangeNgCommercialSeries: string) {
    try {
        return cmsHttpService.get<string>(
            `${appConfig.assets.partials.url}/fai/${rangeNgCommercialSeries}-modal`,
            undefined,
            {
                ttl: Number.parseInt(getAppConfig().cache.ttl.cms),
                tags: [CACHE_TAGS.CMS],
            },
        );
    } catch {}
}
